(function($){

  $("#gform_confirmation_wrapper_8").append('<div class="FormComplete-wrapper"><a href="/contact-us" class="FormComplete-anchor"> <span class="FormComplete-anchor--text"> Contact Us </span> </a></div>');

  $("#gform_confirmation_wrapper_7").append('<div class="FormComplete-wrapper"><a href="/data-centers" class="FormComplete-anchor"> <span class="FormComplete-anchor--text"> Return to Data Center Listings </span> </a></div>');

}(jQuery));
